/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { UsersAuthzResetUserPermissionsManagedPermissionsMutationResponse, UsersAuthzResetUserPermissionsManagedPermissionsPathParams, UsersAuthzResetUserPermissionsManagedPermissions401, UsersAuthzResetUserPermissionsManagedPermissions403 } from "../models/UsersAuthzResetUserPermissionsManagedPermissions";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { usersAuthzResetUserPermissionsManagedPermissions } from "../axios/usersAuthzResetUserPermissionsManagedPermissions";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const usersAuthzResetUserPermissionsManagedPermissionsMutationKey = () => [{ url: '/users-authz/v1/users/:userId/permissions/reset' }] as const

export type UsersAuthzResetUserPermissionsManagedPermissionsMutationKey = ReturnType<typeof usersAuthzResetUserPermissionsManagedPermissionsMutationKey>

export function usersAuthzResetUserPermissionsManagedPermissionsMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = usersAuthzResetUserPermissionsManagedPermissionsMutationKey()
        return mutationOptions<UsersAuthzResetUserPermissionsManagedPermissionsMutationResponse, ResponseErrorConfig<UsersAuthzResetUserPermissionsManagedPermissions401 | UsersAuthzResetUserPermissionsManagedPermissions403>, {userId: UsersAuthzResetUserPermissionsManagedPermissionsPathParams["userId"]}, TContext>({
          mutationKey,
          mutationFn: async({ userId }) => {
            return usersAuthzResetUserPermissionsManagedPermissions(userId, config)
          },
        })

}

/**
 * @description Requires CLIENT_ADMIN role or client API key
 * @summary Reset all permissions for a user
 * {@link /users-authz/v1/users/:userId/permissions/reset}
 */
export function useUsersAuthzResetUserPermissionsManagedPermissions<TContext>(options: 
{
  mutation?: UseMutationOptions<UsersAuthzResetUserPermissionsManagedPermissionsMutationResponse, ResponseErrorConfig<UsersAuthzResetUserPermissionsManagedPermissions401 | UsersAuthzResetUserPermissionsManagedPermissions403>, {userId: UsersAuthzResetUserPermissionsManagedPermissionsPathParams["userId"]}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? usersAuthzResetUserPermissionsManagedPermissionsMutationKey()

          const baseOptions = usersAuthzResetUserPermissionsManagedPermissionsMutationOptions(config) as UseMutationOptions<UsersAuthzResetUserPermissionsManagedPermissionsMutationResponse, ResponseErrorConfig<UsersAuthzResetUserPermissionsManagedPermissions401 | UsersAuthzResetUserPermissionsManagedPermissions403>, {userId: UsersAuthzResetUserPermissionsManagedPermissionsPathParams["userId"]}, TContext>
          

          return useMutation<UsersAuthzResetUserPermissionsManagedPermissionsMutationResponse, ResponseErrorConfig<UsersAuthzResetUserPermissionsManagedPermissions401 | UsersAuthzResetUserPermissionsManagedPermissions403>, {userId: UsersAuthzResetUserPermissionsManagedPermissionsPathParams["userId"]}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<UsersAuthzResetUserPermissionsManagedPermissionsMutationResponse, ResponseErrorConfig<UsersAuthzResetUserPermissionsManagedPermissions401 | UsersAuthzResetUserPermissionsManagedPermissions403>, {userId: UsersAuthzResetUserPermissionsManagedPermissionsPathParams["userId"]}, TContext>
      
}